import { Anchor, Flex, Loader, Text } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import { Link } from 'react-router';

import type { Candidate } from '@entities/candidates';

import { EmptyMessage } from './EmptyMessage';
import { PreviewPositiveCandidate } from './PreviewPositiveCandidate';

type PositiveCandidatesProps = {
  candidates: Candidate[];
  candidatesCount: number;
  isError: boolean;
  isLoading: boolean;
  showEmptyMessage: boolean;
  vacancyId: number;
};

export const PositiveCandidates = ({
  candidates,
  candidatesCount,
  isError,
  isLoading,
  showEmptyMessage,
  vacancyId,
}: PositiveCandidatesProps) => {
  return (
    <Flex direction='column' gap={24} p={24}>
      <Flex align='center' justify='space-between' wrap='wrap' gap={12}>
        <Text size='lg' fw={600} c='primary.7'>
          Выбранные кандидаты
        </Text>

        <Anchor
          component={Link}
          to={`/vacancy-list/${vacancyId}/selected-candidates`}
          c='secondary.7'
          td='none'
          size='md'
          fw={600}
        >
          <Flex align='center' gap={4}>
            {`Все (${candidatesCount})`}
            <IconArrowUpRight size={20} />
          </Flex>
        </Anchor>
      </Flex>

      {isLoading && (
        <Loader size='sm' aria-label='Loading selected candidates' />
      )}

      {isError && (
        <Text size='sm' c='red.7' role='alert'>
          Не удалось загрузить выбранных кандидатов
        </Text>
      )}

      {!isLoading && !isError && candidates.length > 0 && (
        <Flex direction='column' gap={12} w='100%' miw={0}>
          {candidates.slice(0, 2).map(candidate => (
            <PreviewPositiveCandidate
              key={candidate.id}
              candidate={candidate}
            />
          ))}
        </Flex>
      )}

      {!isLoading &&
        !isError &&
        candidates.length === 0 &&
        showEmptyMessage && <EmptyMessage />}
    </Flex>
  );
};
